module.exports = __webpack_public_path__ + "img/12.d8d45fef.jpg";